import React from 'react';
import { Grid, Typography } from '@mui/material';

export default function MachineLocation({ machineDetails }) {
  return (
    <Grid container spacing={2} style={{ paddingTop: '30px' }}>
      <Grid item xs={12}>
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
              Machine Location
            </Typography>
          </div>
          <Grid container spacing={2} className="padding-address-new">
            {machineDetails &&
              machineDetails?.locations &&
              Array.isArray(machineDetails?.locations) &&
              machineDetails?.locations?.length > 0 &&
              machineDetails?.locations?.map((item, i) => (
                <Grid item lg={12} key={i}>
                  <div className="addrs-new-bx-strt addrs-new-bx-strt-new">
                    Address line {i + 1}
                    <div style={{ padding: '20px' }}>
                      <h5>{item?.details?.name}</h5>
                      <p>{item?.details?.address?.fullAddress}</p>
                    </div>
                  </div>
                </Grid>
              ))}
            <Grid item lg={12} className="machineViewAddress">
              <div style={{ padding: '10px', borderColor: '#fff' }} className="addrs-new-bx-strt addrs-new-bx-strt-new">
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  {machineDetails?.location?.name || 'N.A.'}
                </Typography>
                <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                  {machineDetails?.location?.address?.fullAddress || 'N.A.'}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}
